__turbopack_context__.v({
  "actionGlow": "JiSu-W_actionGlow",
  "featureColumn": "JiSu-W_featureColumn",
  "featureList": "JiSu-W_featureList",
  "heading": "JiSu-W_heading",
  "planHeading": "JiSu-W_planHeading",
  "plans": "JiSu-W_plans",
  "primaryAction": "JiSu-W_primaryAction",
  "pro": "JiSu-W_pro",
  "pro-glow": "JiSu-W_pro-glow",
  "proBenefits": "JiSu-W_proBenefits",
  "proFeatures": "JiSu-W_proFeatures",
  "secondaryAction": "JiSu-W_secondaryAction",
  "section": "JiSu-W_section",
});
